import { PathRender } from './Path';
export class ArcPathRender extends PathRender {
    addObject(path, render, domPainter) {
        // FIXME think about better way of providing render coordinates
        if (domPainter) {
            render.setupRenderCoordinates(domPainter);
        }
        render.renderObject(path);
    }
    setupRender(ctx) {
        const renderParams = this.renders[0];
        ctx.lineWidth = renderParams.strokeWidth;
        ctx.strokeStyle = renderParams.strokeColor;
        ctx.fillStyle = renderParams.fillColor;
        ctx.setLineDash(renderParams.lineDash || []);
        ctx.lineCap = renderParams.lineCap;
    }
    renderObject(ctx) {
        ctx.fill(this.path);
        ctx.stroke(this.path);
    }
    toChunks() {
        return Object.values(this.cachedPaths).map(({ path, hadUpdate }) => {
            const pathRender = new ArcPathRender({ path, renders: [this.renders[0]], chunkSize: this.chunkSize });
            pathRender.updateNeeded = hadUpdate;
            return pathRender;
        });
    }
}
